import {Chip} from '@mui/material';
import {SOFT} from 'components/soft/softTheme';
import {HA_CHIP_LABEL, HA_CHIP_STYLE, HOLDS_VIP_CHIP, pairHealthChip, FAILED_OVER_CHIP} from './haCopy';

/** Outlined "HA" chip: 12px, weight 600, #113351, 4px radius. */
export function HAChip() {
	return (
		<Chip
			data-testid="ha-chip"
			label={HA_CHIP_LABEL}
			variant="outlined"
			size="small"
			sx={{...HA_CHIP_STYLE, height: 20, '& .MuiChip-label': {px: '6px'}}}
		/>
	);
}

const toneColor = {success: '#2E7D32', warning: SOFT.color.warning, error: SOFT.color.error} as const;

export function PairHealthChip(props: {health: string}) {
	const c = pairHealthChip(props.health);
	return (
		<Chip
			data-testid="pair-health-chip"
			data-tone={c.tone}
			label={c.label}
			size="small"
			variant="outlined"
			sx={{fontSize: 12, fontWeight: 600, borderRadius: '4px', color: toneColor[c.tone], borderColor: toneColor[c.tone]}}
		/>
	);
}

export function FailedOverChip() {
	return (
		<Chip
			data-testid="failed-over-chip"
			label={FAILED_OVER_CHIP}
			size="small"
			sx={{fontSize: 12, fontWeight: 600, borderRadius: '4px', bgcolor: SOFT.color.warning, color: '#fff'}}
		/>
	);
}

export function HoldsVipChip() {
	return (
		<Chip
			data-testid="holds-vip-chip"
			label={HOLDS_VIP_CHIP}
			size="small"
			variant="outlined"
			sx={{fontSize: 12, fontWeight: 600, borderRadius: '4px', color: SOFT.color.primary, borderColor: SOFT.color.primary}}
		/>
	);
}
